import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=7a3f7b5c&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=js&"
export * from "./privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=7a3f7b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3f7b5c",
  null
  
)

export default component.exports